// TencentPlayer.vue
<template>
  <video
    :id="tcPlayerId"
    class="tencent-player"
    preload="auto"
    playsinline
    webkit-playsinline
    style="width: 100%; height: 100%;"
  ></video>
</template>
<script>
export default {
  name: "TencentPlayer",
  data() {
    return {
      tcPlayerId: "fileID" + this.options.fileID + "tcPlayer" + Date.now(),
      player: null,
    };
  },
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    options: {
      handler(newV, oldV) {
        this.$nextTick(() => {
          this.loadJS();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onoptions(cur, old) {
      this.$nextTick(() => {
        this.loadJS();
      });
    },
    loadTcScript(callback) {
      this.loadScript(callback, {
        id: "tcPlayerScriptId",
        url:
          "https://web.sdk.qcloud.com/player/tcplayer/release/v4.5.2/tcplayer.v4.5.2.min.js",
      });
    },
    loadScript(callback, params) {
      if (document.getElementById(params.id)) {
        callback();
      } else {
        const script = document.createElement("script");
        script.async = true;
        script.src = params.url;
        script.id = params.id;
        script.onload = () => {
          callback();
        };
        document.body.appendChild(script);
      }
    },
    loadJS() {
      if (window.TCPlayer) {
        this.initVideo();
      } else {
        this.loadTcScript(() => {
          this.initVideo();
        });
      }
    },
    initVideo() {
      // 播放按钮
      const Button = TCPlayer.getComponent("Button");
      const BigPlayButton = TCPlayer.getComponent("BigPlayButton");
      BigPlayButton.prototype.createEl = function() {
        var el = Button.prototype.createEl.call(this);
        let _html =
          '<button><svg t="1644397862160" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3095" width="64" height="64"><path d="M298.666667 247.04V682.666667a42.666667 42.666667 0 0 1-85.333334 0V170.666667a42.666667 42.666667 0 0 1 65.024-36.352l554.666667 341.333333a42.666667 42.666667 0 0 1 0 72.704l-554.666667 341.333333a42.666667 42.666667 0 0 1-44.714666-72.704L729.258667 512 298.666667 247.04z" p-id="3096" fill="#ffffff"></path></svg></button>';

        el.appendChild(
          TCPlayer.dom.createEl("div", {
            className: "vjs-button-icon",
            innerHTML: _html,
          })
        );
        return el;
      };

      var controlBar = TCPlayer.getComponent("controlBar");
      controlBar.prototype.options_ = {
        children: [
          "playToggle",
          "volumePanel",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "progressControl",
          "liveDisplay",
          "remainingTimeDisplay",
          "customControlSpacer",
          "playbackRateMenuButton",
          "chaptersButton",
          "descriptionsButton",
          "fullscreenToggle",
        ],
      };

      const playerParm = {
        fileID: this.options.fileID,
        appID: this.options.appID,
        autoplay: this.options.autoplay ? true : false,
        psign: this.options.psign,
        // poster: "	https://mooc.chineseplus.net/dist/img/swiper1.729fad1a.png",
        plugins: {
          // DynamicWatermark: {
          //   type: "text",
          //   speed: 0.6,
          //   content: "中文联盟提供课程",
          //   opacity: 0.7,
          //   fontSize: "14px",
          //   color: "#bdbdbd",
          // },
          // PlayList: {
          //   // 要播放的视频信息集合
          //   data: [
          //     {
          //       fileID: '387702307847129127',
          // 			appID: '1500006438',
          // 			autoplay: false,
          // 			duration: 100,
          // 			// text: '视频1',
          // 			img: "	https://mooc.chineseplus.net/dist/img/swiper1.729fad1a.png",
          // 			psign:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6MTUwMDAwNjQzOCwiZmlsZUlkIjoiMzg3NzAyMzA3ODQ3MTI5MTI3IiwiY3VycmVudFRpbWVTdGFtcCI6MTY2NzIxNjY1MywiY29udGVudEluZm8iOnsiYXVkaW9WaWRlb1R5cGUiOiJSYXdBZGFwdGl2ZSIsInJhd0FkYXB0aXZlRGVmaW5pdGlvbiI6MTB9LCJleHBpcmVUaW1lU3RhbXAiOjIyMDEwMTEyMDAsInVybEFjY2Vzc0luZm8iOnsiZG9tYWluIjoiMTUwMDAwNjQzOC52b2QyLm15cWNsb3VkLmNvbSIsInNjaGVtZSI6IkhUVFBTIn19.AYqjCMFQlo9nn6EMaF0Nol5vVq9miaoUqyvmFF62aSg'
          //     },
          //   ],
          //   title: '腾讯视频列表', // 列表标题
          //   loop: false, // 是否循环播放
          // },
        },
      };
      setTimeout(() => {
        if (!this.player) {
          this.player = TCPlayer(this.tcPlayerId, playerParm);
          // 相关监听
          this.playerOn();
        } else {
          this.player.loadVideoByID(playerParm);
        }
      });
    },
    playerOn() {
      // 监听播放完成
      this.player.on("ended", () => {
        this.$emit("ended");
      });

      // 监听播放暂停
      this.player.on("pause", () => {
        const currentTime = this.player.currentTime();
        const duration = this.player.duration();
        this.$emit("pause", { currentTime, duration });
      });

      // 监听播放/恢复播放
      this.player.on("play", () => {
        this.$emit("play");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("https://imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css");
.tcp-skin ::v-deep {
  .tcp-right-click-popup-menu {
    display: none;
  }
  .vjs-play-progress {
    background-color: #ff6429;
  }
  .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {
    color: #ff6429;
  }
  .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {
    color: #ff6429;
  }
  .vjs-play-control .vjs-icon-placeholder:before {
    color: #ff6429;
  }
  .vjs-volume-panel .vjs-volume-level {
    background-color: #ff6429;
  }
  .vjs-mute-control .vjs-icon-placeholder:before {
    color: #ff6429;
  }
}

@media screen and (max-width: 480px) {
  #player-container-id {
    width: 100%;
    height: 240px;
  }
}
</style>
